import * as GroupsActionTypes from '../../types/groups';

export default function groups(state = {}, action = {}) {
    switch (action.type) {
        case GroupsActionTypes.SET_GROUPS: {
            return action.payload;
        }

        case GroupsActionTypes.ADD_GROUP: {
            const { id } = action.payload;
            return { ...state, [id]: action.payload };
        }

        case GroupsActionTypes.DELETE_GROUP: {
            const { [action.payload]: _x, ...rest } = state;
            return rest;
        }

        default: {
            return state;
        }
    }
}
